export { default as SupportingChartLinks } from "./component";
